module.exports = __webpack_public_path__ + "static/adineuePRO-BlackItalicWeb-e3536560351b0eb26c5e8e2a815bc4dd.woff";